module.exports = __webpack_public_path__ + "img/edge_activites_kite_surf.5806ae07.svg";